/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateContainerRequest { 
    number: number;
    name: string;
    description?: string | null;
    facilityId: string;
    socketTypeId: number;
    subnet: string;
    energyCrqParameterId?: string | null;
}

